import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "airline",
    "flightNumber",
    "departureAirport",
    "arrivalAirport",
    "departureTime",
    "arrivalTime",
    "timeSpan",
    "travelTime",
    "item",
    "emptyMessage",
    "tableContainer",
  ];

  static values = {
    locale: String,
    minutes: String,
    hours: String,
  };

  localeDateTime(dateTimeString) {
    const dateTime = new Date(dateTimeString);

    const time = dateTime.toLocaleTimeString(`${this.localeValue}`, {
      hour: "2-digit",
      minute: "2-digit",
    });
    const date = dateTime.toLocaleDateString(`${this.localeValue}`);

    return `${date}, ${time}`;
  }

  timeSpan(depTime, arrTime) {
    let departure = new Date(depTime);
    let arrival = new Date(arrTime);
    const suffix = arrival.getDate() > departure.getDate() ? " (+1)" : "";

    departure = departure.toLocaleTimeString(`${this.localeValue}`, {
      hour: "2-digit",
      minute: "2-digit",
    });

    arrival = arrival.toLocaleTimeString(`${this.localeValue}`, {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${departure} - ${arrival}${suffix}`;
  }

  // Formats a duration given in total minutes as "Xh Ym", e.g. "3 h 25 min".
  // Replaces the old travelTime() which computed duration from airport UTC offsets
  // — the HitchHiker FAPI returns duration_minutes directly on each flight.
  formatDuration(minutes) {
    if (!minutes) return "";

    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    const hStr = h > 0 ? `${h} ${this.hoursValue}` : "";
    const mStr = m > 0 ? ` ${m} ${this.minutesValue}` : "";

    return `${hStr}${mStr}`.trim();
  }

  handleResults(event) {
    // Reset: keep only the first item row (remove dynamically added clones)
    this.itemTargets.forEach((item, index) => {
      if (index !== 0) item.remove();
    });

    if (event.detail.error || !event.detail.flights) {
      this.tableContainerTarget.classList.add("hidden");
      this.emptyMessageTarget.classList.remove("hidden");
    } else {
      this.fillData(event.detail.flights);
    }

    event.preventDefault();
  }

  fillData(data) {
    this.tableContainerTarget.classList.remove("hidden");
    this.emptyMessageTarget.classList.add("hidden");

    const parentNode = this.itemTarget.parentElement;

    data.forEach((element, index) => {
      if (!this.itemTargets[index]) {
        parentNode.insertBefore(this.itemTarget.cloneNode(true), null);
      }

      // Field names match the HitchHiker FAPI response shape serialised by
      // Api::FlightsController#serialize_flight_result.
      this.airlineTargets[index].innerHTML = element.airline_code;
      this.flightNumberTargets[index].innerHTML = element.flight_number;
      this.departureAirportTargets[index].innerHTML = element.departure_airport;
      this.arrivalAirportTargets[index].innerHTML = element.arrival_airport;
      this.timeSpanTargets[index].innerHTML = this.timeSpan(
        element.departure_at,
        element.arrival_at
      );
      this.travelTimeTargets[index].innerHTML = this.formatDuration(
        element.duration_minutes
      );
      this.departureTimeTargets[index].innerHTML = element.departure_at;
      this.arrivalTimeTargets[index].innerHTML = element.arrival_at;
    });
  }
}
